
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PageHeaderBase',
  props: {
    rowStart: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return {};
  },
});
